import { Fragment } from 'react'

import { AlertMessage } from 'reactShared/components/AlertMessage'

import { buildText } from './utils/message'
import * as S from './styled'

const UnavailableProductMessage = ({ isAssistedSale, hidePrice }) => {
  const { title, message } = buildText({ isAssistedSale, hidePrice })

  return (
    <Fragment>
      <S.Title>{title}</S.Title>

      {message && (
        <AlertMessage type="warning">
          {message}
        </AlertMessage>
      )}
    </Fragment>
  )
}

export default UnavailableProductMessage
